'use strict';

var WritableStream = require('stream').Writable,
    util = require('util');

var DevNullStream = module.exports = function () {
    WritableStream.call(this);
};

util.inherits(DevNullStream, WritableStream);

DevNullStream.prototype._write = function (chunk, encoding, cb) {
    cb();
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/parse5/lib/sax/dev_null_stream.js
 ** module id = 715
 ** module chunks = 50
 **/